import React from "react";
import { Row } from "antd";
import Analytics from '../../helpers/Analytics';

const NotFound = () => {
  Analytics.pageView('/not-found');

  return (
    <Row className="notfound__wrapper" type="flex" align="middle" justify="center">
      <h1>404</h1>
      <p>This page does not exist.</p>
    </Row>
  )
}

export default NotFound;